import type { FC } from 'react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { useDealFiltersOpsDispatch } from '../../DealFiltersProvider'
import { DealFiltersTickTrait } from '../../provider/types'
import { classNames } from '@g4g/utils/src/react/class-names'

const FilterFeedbackClose: FC<{ trait: DealFiltersTickTrait; id: string }> = ({ trait, id }) => {
  const dispatch = useDealFiltersOpsDispatch()

  return (
    <div
      onClick={() =>
        dispatch({
          type: 'update-tick-trait',
          name: id,
          trait: trait,
          active: false,
        })
      }
      className={classNames(
        'flex items-center justify-center w-5 h-5',
        'cursor-pointer text-white/20 hover:text-white/50'
      )}
    >
      <XMarkIcon className="w-5 h-5" />
    </div>
  )
}

export default FilterFeedbackClose
